var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOhneFuellung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 380 230",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1101C",
    transform: "matrix(1.01145,0,0,0.937902,-31.2465,-20.3767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pfosten diagonal",
    transform: "matrix(0.98868,-0,-0,1.06621,30.8928,21.7258)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 8.473,
    y: 15.515,
    width: "362.45px",
    height: "12.189px",
    transform: "matrix(0.998486,0,0,0.937614,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pfosten links",
    transform: "matrix(1,0,0,1,-155.641,1.49214e-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pfosten diagonal",
    transform: "matrix(0.98868,-0,-0,1.06621,186.534,21.7258)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 27.908,
    y: 26.833,
    width: "12.189px",
    height: "203.264px",
    transform: "matrix(0.937614,0,0,0.99639,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pfosten rechts",
    transform: "matrix(1,0,0,1,155.641,0.333568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pfosten diagonal",
    transform: "matrix(0.98868,-0,-0,1.06621,-124.748,21.3923)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 363.704,
    y: 27.056,
    width: "12.189px",
    height: "202.951px",
    transform: "matrix(0.937614,0,0,0.999757,0,0)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "363px",
    height: "13px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWsAAAANCAYAAABvnE+LAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA70lEQVR4nO3ZSw6EIBBFUTHsxZ27J+fO2AP2uLsT5GNZPnPPlF9hwjOBsK7rMQEAHm32LgAAcI6wBgABhDUACIjzXJ/XIQTDUnzX9dqbhTftBf2O4z3PUXfsxet71a4bl2UpdrA4+NZh4hFWCgGpUCPaKYSyR43Wa1rMX5ozpJT+Ws8Odeuh7wmJ3mAZCaTRMLsyDFV/aPwQvlkFhlIQjc41Mr53bM+41jFn/X/bubMGAAFx3/diB65BnrtmK4Ua0Y5rEJ81774Gidu2VU/EA6OGN+0F/RRCvBYPjNMUc87GpQAARnFnDQACCGsAEPABiL9jgHNuFDcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "13px",
    height: "204px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAADMCAYAAACoXyltAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABC0lEQVRoge2WwRGDIBRE9zterUDv9pB0YoGMhSTpwQJsA3IzSDBjEhTQ/TeVN8us+/kInFJKXQDc67oGAIzjeO267mGvKVxoTSUOlUsfRCSs0hGhUinl2jR7FhHp+1601i8IgLYXFUWBtm3RNA0AoKqq2zAM/28vx0TYKj7FN8i3yH3HlO8O5Rajn5XSgcJYvqafEjcisuUiMjl2luxFhDgAjgOxnwjNi52bKZTBPWKTSyIDSygWxOwRIkSIECFCX9fi+DTGhFUiRGhekbNnq/gUI7rn2477LvGfe0SIhyWheXkTYYyZEpHYwXJWKEzn8ljeGmI/BYXWBJZD7RO0ySWRlu8ORR4AmcfoCeIQafegc+3MAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "13px",
    height: "203px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAADLCAYAAAC1WhnVAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABGklEQVRoge3WSw6CMBAG4L8NCSQ9Auy5g96EAzZcwqXegQNwA9fgwqhQyiPyauHvsvI5MDMMFTCW1voC4B7HMQCgLMtrlmWP5jXSRFOW4yjo+0EIsWykI6JAa62MvUhKCSnf/xeGYZTnuaqq6ocAPFuhpUSapkiSBACglLoVRTH/9nzsiGYUW8QOsl1k7rHLN0e+tdHfkVZBO2ZvyvvkePZ2rpMQ4psxD3vPN8QPgD9obCyzTkTtxY7wFHlwjuA0InIVsfeIiIiIiIi2Qb3f3Lqul41ERNRey/VeE9jwjomw3Y6553idjog494ja6xTT6KyoU9xPXYZq5fgz+YjGXg2O5T602jmCKR9Cq8xypnwOWiZ7257L3Zl7Lztiah7UkKYUAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhneFuellung);
export default __webpack_public_path__ + "static/media/ohne_fuellung.4ee19aa54060f6edf6944992ea0da553.svg";
export { ForwardRef as ReactComponent };